export const selectOptionsLoanProductTypeQuickApp = [
  { label: "Fix & Flip", value: "Fix and Flip" },
  { label: "Fix & Rent ", value: "Fix and Rent" },
  { label: "Bridge", value: "Stabilized Bridge" },
  { label: "Ground Up Construction ", value: "Ground Up Construction" },
  { label: "Rental (DSCR)", value: "DSCR" },
];
